import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { push, goBack } from 'connected-react-router';
import { showAlert } from 'actions/common/alert';
import Payment from 'components/OrderAggregators/Payment';

const mapStateToProps = ({ orderAggregatorsPayment }) => ({
  ...orderAggregatorsPayment
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      push,
      showAlert,
      goBack
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Payment);



// WEBPACK FOOTER //
// ./src/containers/OrderAggregators/Payment/index.js